
//import { createApp } from 'vue'
//import App from './App.vue'

//createApp(App).use(Quasar, quasarUserOptions).mount('#app')

import { createApp } from 'vue'
//import Popper from "vue3-popper";
//  Guide top use Popper --  https://valgeirb.github.io/vue3-popper/guide/getting-started.html
//  Popper API  --  https://valgeirb.github.io/vue3-popper/guide/api.html
import Datepicker from '@vuepic/vue-datepicker';

// View Picker Site -- https://vue3datepicker.com/installation/
import '@vuepic/vue-datepicker/dist/main.css'
//import Host from './components/CalendarMonth.vue'
import Host from './App.vue'
//import Host from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import ZadokPlugin from './ZadokPlugin'
//-------------------------------------------------------------
import router from './router'

import moment from 'moment'

//Vue.prototype.moment = moment

//import BootstrapVue from 'bootstrap-vue'
//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

//import './plugins/bootstrap-vue'
createApp(Host)
    .use(Quasar, quasarUserOptions)
    .use(ZadokPlugin)    
    .use(router)
    //.use(BootstrapVue)
    //.component("Popper", Popper)
    .component("moment", moment)
    .component('Datepicker', Datepicker)    
    .mount('#app');


//  Help with VueJS - API --  https://vuejs.org/api/application.html